import { Directive } from '@angular/core';
import { PaymentModel } from 'src/app/core/models/commerce/payment.model';

export type SortColumn = keyof PaymentModel | '';
export type SortDirection = 'asc' | 'desc' | '';

@Directive({
  selector: '[appPaymentList]'
})
export class PaymentListDirective {

  constructor() { }

}
